/** @format */

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
//import Components
import MobileMenu from "../mobileMenu";
import { Search } from "../global/search";
//importing Assets
import Photo from "../../Assets/images/ahmedeldesoky.jpeg";
import { MessageNavIcon } from "../svg";
import { IoIosArrowDown } from "react-icons/io";
import Icons from "../../Assets/Icons";
// import "./index.scss";
const TopNav = ({ isMenuOpen, toggleMenu }) => {
  return (
    <div className={`top-nav`}>
      <div
        className={`top-nav__box ${isMenuOpen && "top-nav__box--add-margin"}`}>
        {/* <MobileMenu /> */}
        <div style={{ width: "40%" }}>
          <Search />
        </div>
        <UserNav />
      </div>
      <div className='top-nav__mobile-navbar'>
        <Icons name='navLogo' />
        <Icons onClick={toggleMenu} name='burgerMenu' />
      </div>
    </div>
  );
};

export default TopNav;

export const UserNav = () => {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("jwt");
    navigate("/login");
  };
  return (
    <div className='user-nav'>
      <div className='user-nav__noti'>
        <MessageNavIcon />
      </div>
      <Link to='/profile-guarantor'>
        <div className='user-nav__img-box'>
          <img src={Photo} alt='profile pic' className='user-nav__img' />
        </div>
      </Link>
      <h2 className='ternary__heading  '>عبد الله احمد</h2>
      {/* <IoIosArrowDown style={{ color: "#ff8900", cursor: "pointer" }} /> */}
      <h3 onClick={logout} style={{ cursor: "pointer" }}>
        خروج
      </h3>
    </div>
  );
};
